import { ReactElement, useState, useCallback } from 'react';
import { FieldProps, ErrorMessage, useFormikContext, getIn } from 'formik';
import classnames from 'classnames';
import styles from './LimitedTextAreaLarge.module.scss';

interface iProps extends FieldProps {
  title?: string;
  limit: number;
  isMandatory: boolean;
  disabled?: boolean;
  placeholder?: string;
}

const LimitedTextAreaLargeUpdated = ({ field, form, title = '', limit, disabled = false, isMandatory, placeholder = '' }: iProps): ReactElement => {
  const { values, errors, touched }: { values: any; errors: any; touched: any } = useFormikContext();
  const hasError = getIn(errors, field.name);
  const touchedError = getIn(touched, field.name);
  const [content, setContent] = useState(values[field.name].slice(0, limit));
  const setFormattedContent = useCallback(
    (text: string) => {
      setContent(text.slice(0, limit));
    },
    [limit, setContent],
  );

  return (
    <div
      className={classnames({
        [styles.container]: true,
        [styles.titlePresent]: title,
      })}>
      {title && (
        <div
          className={classnames({
            [styles.title]: true,
            [styles.titleError]: hasError && touchedError,
          })}>
          <span className={styles.titleBold}>{title}</span>
          {!isMandatory && <span className={styles.optional}> ( optional )</span>}
        </div>
      )}
      <div className={styles.inputContainer}>
        <textarea
          className={classnames({
            [styles.formInput]: true,
            [styles.inputError]: hasError && touchedError,
            [styles.disabled]: disabled,
          })}
          onChange={(event) => {
            let correctedString = event.target.value.replace(/‘/g, "'");
            correctedString = correctedString.replace(/’/g, "'");
            correctedString = correctedString.replace(/“/g, '"');
            correctedString = correctedString.replace(/”/g, '"');
            correctedString = correctedString.replace(/–/g, '-');
            correctedString = correctedString.replace(/—/g, '-');
            setFormattedContent(correctedString);
            form.setFieldTouched(field.name);
            form.setFieldValue(field.name, correctedString);
          }}
          value={getIn(values, field.name)}
          disabled={disabled}
          required={isMandatory}
          placeholder={placeholder}
          maxLength={limit}
          aria-label="Text Area"
        />
        <p>{`${limit - content.length} characters remaining`}</p>
      </div>
      <ErrorMessage className={styles.errorMsg} name={field.name} component="span" />
    </div>
  );
};

export default LimitedTextAreaLargeUpdated;
